<kanaal-overview [assign]="this.assign()" [system]="this.system!"></kanaal-overview>
